import React from "react";
export default function SVGNuts() {
  return (
    <svg viewBox="0 0 472.303 472.303">
      <g fill="#000000">
        <path
          fill="#000000"
          d="M231.125,239.939c-2.284-3.958-7.26-6.83-11.83-6.83H96.97c-4.57,0-9.546,2.872-11.83,6.83L23.978,345.875
     c-2.285,3.958-2.285,9.702,0,13.66L85.14,465.473c2.284,3.957,7.26,6.83,11.83,6.83h122.325c4.57,0,9.546-2.873,11.83-6.83
     l61.162-105.938c2.285-3.958,2.285-9.702,0-13.66L231.125,239.939z M158.132,410.893c-32.085,0-58.188-26.103-58.188-58.188
     c0-32.084,26.103-58.187,58.188-58.187c32.085,0,58.188,26.103,58.188,58.187C216.32,384.791,190.217,410.893,158.132,410.893z"
        />
        <path
          fill="#000000"
          d="M448.325,225.092l-36.181-62.667c-2.284-3.958-7.26-6.83-11.83-6.83h-72.361c-4.57,0-9.546,2.872-11.83,6.83
     l-36.182,62.667c-2.285,3.958-2.285,9.702,0,13.66l36.182,62.668c2.284,3.958,7.26,6.83,11.83,6.83h72.361
     c4.57,0,9.546-2.872,11.83-6.83l36.181-62.668C450.61,234.794,450.61,229.05,448.325,225.092z M364.132,259.252
     c-15.069,0-27.329-12.26-27.329-27.33c0-15.068,12.26-27.328,27.329-27.328s27.33,12.26,27.33,27.328
     C391.462,246.992,379.202,259.252,364.132,259.252z"
        />
        <path
          fill="#000000"
          opacity="0.7"
          d="M65.166,140.904l49.696,49.293c2.109,2.09,5.659,3.549,8.634,3.549l70.024-0.285c2.986-0.011,6.541-1.5,8.645-3.62
     l49.291-49.695c2.103-2.12,3.562-5.686,3.55-8.671l-0.284-69.988c-0.011-2.986-1.5-6.541-3.62-8.645L201.406,3.549
     C199.296,1.459,195.747,0,192.736,0l-69.988,0.285c-2.988,0.011-6.544,1.5-8.644,3.62L64.811,53.6
     c-2.102,2.119-3.562,5.685-3.55,8.671l0.285,69.989C61.557,135.246,63.046,138.801,65.166,140.904z M157.966,55.631h0.169
     c22.648,0,41.148,18.426,41.24,41.074c0.092,22.742-18.334,41.318-41.073,41.41h-0.169c-22.648,0-41.149-18.426-41.241-41.073
     C116.8,74.301,135.226,55.723,157.966,55.631z"
        />
      </g>
    </svg>
  );
}
